<div class="hire-modal">
  <h2 class="modal-title">Nós formatamos o seu livro para você.</h2>
  <div class="modal-desc">
    Profissionais diagramadores especializados com o selo de aprovação Feira do Livro cuidam de toda a parte técnica: diagramação, padronização e preparação completa do conteúdo.
  </div>
  <div class="modal-price">
    Custo deste serviço R$ 499,00
  </div>
  <div class="modal-extra">
    Ao contratar este serviço, você garante a melhor experiência de publicação. A Feira do Livro cuida de tudo para que você possa focar apenas no mais importante: escrever.
  </div>
  <div class="modal-actions">
    <button class="back-btn" (click)="onBack()" [disabled]="isLoading">
      {{ isLoading ? 'Processando...' : 'Não, obrigado!' }}</button>
    <button class="continue-btn" (click)="onContinue()" [disabled]="isLoading">
      {{ isLoading ? 'Processando...' : 'Sim, contratar' }}
    </button>
  </div>
</div>